import uiComponents from '@sparklayer-io/spark-dash-ui/i18n/en/components';
import addonGraphics from './addon-graphics.json' with { type: 'json' };
import b2bFlowDiagram from './b2b-flow-diagram.json' with { type: 'json' };
import credentialField from './credential-field.json' with { type: 'json' };
import documentGraphics from './document-graphics.json' with { type: 'json' };
import helpCardGraphics from './help-card-graphics.json' with { type: 'json' };
import locationsPicker from './locations-picker.json' with { type: 'json' };
import popularAddons from './popular-addons.json' with { type: 'json' };
import sectionTabs from './section-tabs.json' with { type: 'json' };
import sortableList from './sortable-list.json' with { type: 'json' };
import sparkjsUpgradeAlert from './sparkjs-upgrade-alert.json' with { type: 'json' };
import staffSetting from './staff-setting.json' with { type: 'json' };

export default {
  ...uiComponents,
  addon_graphics: addonGraphics,
  b2b_flow_diagram: b2bFlowDiagram,
  credential_field: credentialField,
  document_graphics: documentGraphics,
  help_card_graphics: helpCardGraphics,
  locations_picker: locationsPicker,
  popular_addons: popularAddons,
  section_tabs: sectionTabs,
  sortable_list: sortableList,
  sparkjs_upgrade_alert: sparkjsUpgradeAlert,
  staff_setting: staffSetting,
};
